import React from 'react';
import { useIntl, MessageDescriptor, defineMessages } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { Panel, PanelBody, PanelHead } from '../primitives/Panel';

interface TrackAboutCardProps {
  album: { name: string | null; releaseDate: string | null; label: string | null; albumType: string | null } | null;
  isrc: string | null;
}

const messages = defineMessages({
  title: {
    id: 'app.sml.track.details.about.title',
    defaultMessage: 'About this track',
  },
  album: {
    id: 'app.sml.track.details.about.album',
    defaultMessage: 'Album',
  },
  released: {
    id: 'app.sml.track.details.about.released',
    defaultMessage: 'Released',
  },
  label: {
    id: 'app.sml.track.details.about.label',
    defaultMessage: 'Label',
  },
  type: {
    id: 'app.sml.track.details.about.type',
    defaultMessage: 'Type',
  },
  isrc: {
    id: 'app.sml.track.details.about.isrc',
    defaultMessage: 'ISRC',
  },
});

const capitalize = (s: string): string => s.charAt(0).toUpperCase() + s.slice(1);

const TrackAboutCardComponent: React.FC<TrackAboutCardProps> = ({ album, isrc }) => {
  const intl = useIntl();

  const rows: { label: MessageDescriptor; value: string }[] = [];
  const push = (label: MessageDescriptor, value: string | null | undefined): void => {
    if (value !== null && value !== undefined && value !== '') {
      rows.push({ label, value });
    }
  };
  push(messages.album, album?.name);
  push(messages.released, album?.releaseDate);
  push(messages.label, album?.label);
  push(messages.type, album?.albumType ? capitalize(album.albumType) : null);
  push(messages.isrc, isrc);

  if (rows.length === 0) {
    return null;
  }

  return (
    <Panel className="h-100">
      <PanelHead titleAs="h2" title={intl.formatMessage(messages.title)} />
      <PanelBody>
        <dl className="row mb-0">
          {rows.map((row) => (
            <React.Fragment key={row.label.id}>
              <dt className="col-4 text-muted small fw-normal">{intl.formatMessage(row.label)}</dt>
              <dd className="col-8 small mb-2">{row.value}</dd>
            </React.Fragment>
          ))}
        </dl>
      </PanelBody>
    </Panel>
  );
};

export const TrackAboutCard = TypedMemo(TrackAboutCardComponent);
